import { useMemo } from 'react';
import { translate } from '../i18n/LocaleProvider';
import { getDiscountPercentageLocale } from '../i18n/LocaleHelper';
import { Currencies } from '../constants';
import { getTravellerDetailFromMember } from './TravellerHelper';

export const getBasePrice = item => {
  const { baseRate = {} } = item;
  const { value } = baseRate;
  return Number(value);
};

export const roundPrice = baseValue => Math.ceil(baseValue);

export const percentPromotion = (baseValue, strikethroughPrice) => {
  if (!strikethroughPrice) {
    return 0;
  }
  return Math.trunc(
    ((strikethroughPrice - baseValue) / strikethroughPrice) * 100
  );
};

export const discountText = (baseValue, strikethroughPrice, locale) => {
  const percent = percentPromotion(baseValue, strikethroughPrice);
  if (percent) {
    return translate('hotelCard.priceOff', {
      percent: getDiscountPercentageLocale(percent, locale),
    });
  }
  return null;
};

export const useDisplayPrice = (
  basePrice,
  strikethroughPrice,
  applyBigpoints,
  baseRateAfterBigPointsDeduction,
  bigMembership
) => {
  const roundBasePrice = useMemo(() => {
    if (bigMembership && applyBigpoints) {
      return (
        baseRateAfterBigPointsDeduction &&
        roundPrice(baseRateAfterBigPointsDeduction?.value)
      );
    } else {
      return basePrice && roundPrice(basePrice?.value);
    }
  }, [
    basePrice,
    strikethroughPrice,
    applyBigpoints,
    baseRateAfterBigPointsDeduction,
    bigMembership,
  ]);
  const regex = /[kKmM]/;
  const roundStrikethroughPrice =
    strikethroughPrice && regex.test(strikethroughPrice?.value)
      ? strikethroughPrice?.value
      : roundPrice(strikethroughPrice?.value);
  return [roundBasePrice, roundStrikethroughPrice];
};

export const convertToCountrySelectItems = (countries = []) =>
  countries.map(({ countryCode, name }) => ({
    label: name,
    value: countryCode,
  }));

export const convertToCountryDialingCodeSelectItems = (countries = []) =>
  countries.map(({ dialingCode, name, countryCode }) => ({
    label: `${name} (+${dialingCode})`,
    value: countryCode,
    dialingCode,
    countryName: name,
    countryCode,
  }));

export const convertToFavoriteMembersSelectItems = (favoriteMembers = []) =>
  favoriteMembers
    ? favoriteMembers.map(favoriteMember => {
        const { firstName, lastName, id } = favoriteMember;
        return {
          label: `${firstName} ${lastName}`,
          value: id || '',
          item: getTravellerDetailFromMember(favoriteMember),
        };
      })
    : [];

export const formatPriceByCurrency = (currency = '') => {
  const noDecimalCurrencies = [Currencies.JPY, Currencies.IDR];

  return noDecimalCurrencies.indexOf(currency) >= 0
    ? { minimumFractionDigits: 0 }
    : { minimumFractionDigits: 2 };
};
